import {Fragment} from "react";
import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import {FormInput} from "root/ReactHookForm/FormComponents";
import {EditUserFieldNames, EditUserSubFormIdentifiers} from "root/s360components/Modals/UserEdit/useModalEditUser";

///todo - find a better place for this
/**
 *
 * isSchool360ValidUsername - Rules summary:
 * 1. Only contains letters, numbers and at most one occurence of either '.' or '_'
 * 2. Does not have both '.' and '_'
 * 3. Does not start or end with '.' or '_'
 *
 * @param str
 * @returns {boolean}
 */
const isSchool360ValidUsername = str => /^(?![_\.]|.*[._]$)(?!.*[._].*[._])[\w.]+$/gi.test(str);

const HookFormFragmentRenameUser = ({control, register, formErrors, sectionName, readOnly}) =>
{
    const validateUsername = (val) =>
    {

        if (val === null || val === "")
        {
            return "Please enter a Username.";
        }
        else if (isSchool360ValidUsername(val) === false)
        {
            return "Username must not contain special characters (except one occurrence of '.') E.g. john.smith2"
        }
    }

    return (
        <Fragment>
            <BootstrapRow>
                <BootstrapCol>
                    <div className='rename-warnings'>
                        <div>
                            <h5>BE AWARE</h5>
                        </div>
                        <div>
                            <p> - This user may not be able to use Google Chat for up to 3 days.</p>
                        </div>
                        <div>
                            <p> - This user's previous email will become an alternate email (email alias) so email delivery isn't interrupted.</p>
                        </div>
                        <div>
                            <p> - Username must be in the format 'john.smith'  OR john.smith3.</p>
                        </div>
                        <div className='danger-highlight'>
                            <p> - Once confirmed, the old username will be reserved and can no longer be used.</p>
                        </div>
                    </div>
                    <label className='form-label'>Username</label>
                    <FormInput register={register} sectionName={EditUserSubFormIdentifiers.RENAME}
                               name={EditUserFieldNames.USERNAME} formErrors={formErrors}
                               rules={{validate: validateUsername}}/>
                </BootstrapCol>
            </BootstrapRow>
        </Fragment>
    )
}

export default HookFormFragmentRenameUser;